import React, { useState } from "react";
import { IonSpinner, IonMenu, IonContent, IonPage } from "@ionic/react";
import { menuController } from "@ionic/core/components";
import moment from "moment";

import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Row, Col } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import {
  Search,
  Grid,
  CardList,
  Check,
  X,
  Funnel,
} from "react-bootstrap-icons";
import styled from "styled-components";
import Dropdown from "react-bootstrap/Dropdown";
import Pagination from "react-bootstrap/Pagination";
import { useTranslation } from "react-i18next";
import MultiRangeSlider from "./MultiRangeSlider";

const IonHeaderStyle = {
  background: "#ffffff",
};

const TableStyle = {
  marginTop: 14,
  borderCollapse: "separate",
  borderSpacing: 0,
};
const divTileStyle = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  overflow: "auto",
  flexWrap: "wrap",
};
const Tile = styled.div`
  display: flex;
  margin: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 2px 2px 2px #ccc;
  width: 100%;
  height: 165px;
  justify-content: space-evenly;
  align-items: center;
`;

const BallDatabaseSearchInput = styled(Form.Control)`
  &::placeholder {
    font-size: 12px;
    text-decoration: italic;
  }
`;

const FilterCol = styled(Col)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 2px;
  padding-bottom: 2px;
`;

const RangeSelector = styled(MultiRangeSlider)`
  background: none;
  border: none !important;
  box-shadow: none !important;
  width: 100%;
`;

const FilterCheck = styled(Form.Check)`
  font-weight: bold;
  font-size: 12px;
  margin-left: 20px;
  flex: 1;
`;

const FilterTitle = styled.span`
  font-weight: bold;
  font-size: 12px;
  text-align: right;
  padding-right: 20px;
  flex: 1;
`;

const FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const PageSizeDropdown = styled(Dropdown)`
  & > button {
    width: 250px;
  }
`;

const TableHeader = styled.th`
  vertical-align: middle;
`;

const TableData = styled.td`
  vertical-align: middle;
`;

const BallSearch = ({
  bowlingdata,
  totalRecords,
  loading,
  ballSearch,
  setBallSearch,
  pageSize,
  setPageSize,
  actPage,
  setActPage,
  rangeInitial,
  setRangeInitial,
  rangeFinal,
  setRangeFinal,
  filters,
  searchBaseFilters,
  rgMinValue,
  setRgMinValue,
  rgMaxValue,
  setRgMaxValue,
  diffMinValue,
  setDiffMinValue,
  diffMaxValue,
  setDiffMaxValue,
  intMinValue,
  setIntMinValue,
  intMaxValue,
  setIntMaxValue,
  size,
  setSize,
  manufacturer,
  setManufacturer,
  coreType,
  setCoreType,
  coreName,
  setCoreName,
  coverstock,
  setCoverstock,
  order,
  handleBallSearch,
  isPhone,
  selectedBalls,
  getBalldatabaseInfo,
  onSelect,
  api_key,
  api_secret,
  api_url,
}) => {
  const [isList, setIsList] = useState(!isPhone);

  const [showApplyFilter, setShowApplyFilter] = useState(false);
  const [showDiscardFilter, setShowDiscardFilter] = useState(false);

  const [showBallInfo, setShowBallInfo] = useState(false);
  const [selectedBall, setSelectedBall] = useState(null);

  const [useRGFilter, setUseRGFilter] = useState(false);
  const [useDiffFilter, setUseDiffFilter] = useState(false);

  const { t } = useTranslation();
  const pageSizeClickHandler = (size) => {
    setPageSize(size);
    setRangeInitial(size * (actPage - 1));
    setRangeFinal(size * actPage - 1);
    handleBallSearch({
      filter: ballSearch,
      rangeInitial: size * (actPage - 1),
      rangeFinal: size * actPage - 1,
      order,
      filters: {
        rg: [searchBaseFilters.rg[0], searchBaseFilters.rg[1]],
        diff: [searchBaseFilters.diff[0], searchBaseFilters.diff[1]],
      },
    });
  };

  const getEndPage = () => Math.ceil(totalRecords / pageSize);

  const getPages = () => {
    let pages = [];
    let startPage = 1;
    let endPage = getEndPage();
    if (endPage > 5) {
      if (actPage > endPage - 3) {
        startPage = endPage - 4;
        endPage = endPage;
      } else {
        if (actPage > 3) {
          startPage = actPage - 2;
          endPage = actPage + 2;
        } else {
          startPage = 1;
          endPage = endPage > 5 ? 5 : endPage;
        }
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <Pagination.Item
          active={i === actPage}
          onClick={() => {
            setActPage(i);
            setRangeInitial(pageSize * (i - 1));
            setRangeFinal(pageSize * i - 1);
            handleBallSearch({
              filter: ballSearch,
              rangeInitial: pageSize * (i - 1),
              rangeFinal: pageSize * i - 1,
              order,
              filters: {
                rg: [searchBaseFilters.rg[0], searchBaseFilters.rg[1]],
                diff: [searchBaseFilters.diff[0], searchBaseFilters.diff[1]],
              },
            });
          }}
        >
          {i}
        </Pagination.Item>
      );
    }
    return pages;
  };

  return (
    <>
      <Modal.Body style={{ minHeight: "60vh" }}>
        <IonMenu
          menuId="filter-menu"
          contentId="index-page"
          swipeGesture={false}
        >
          <IonContent style={IonHeaderStyle}>
            <div
              style={{
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  height: "100%",
                  width: "96%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "1em",
                  marginBottom: "1em",
                }}
              >
                <div>
                  <div>
                    <Row>
                      <FilterCol xs={12}>
                        <FilterContainer>
                          <PageSizeDropdown>
                            <Dropdown.Toggle variant="secondary">
                              {pageSize}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  pageSizeClickHandler(12);
                                }}
                              >
                                12
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  pageSizeClickHandler(24);
                                }}
                              >
                                24
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  pageSizeClickHandler(36);
                                }}
                              >
                                36
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  pageSizeClickHandler(48);
                                }}
                              >
                                48
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  pageSizeClickHandler(60);
                                }}
                              >
                                60
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </PageSizeDropdown>
                        </FilterContainer>
                      </FilterCol>
                      <FilterCol xs={12}>
                        <FilterContainer>
                          <PageSizeDropdown>
                            <Dropdown.Toggle variant="secondary">
                              {size ? size : "Weight"}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {filters[0]?.sizes.map((size) => (
                                <Dropdown.Item
                                  onClick={() => {
                                    setShowApplyFilter(true);
                                    setSize(size.size);
                                  }}
                                >
                                  {size.size}
                                </Dropdown.Item>
                              ))}
                            </Dropdown.Menu>
                          </PageSizeDropdown>
                        </FilterContainer>
                      </FilterCol>
                      <FilterCol xs={12}>
                        <FilterContainer>
                          <PageSizeDropdown>
                            <Dropdown.Toggle variant="secondary">
                              {manufacturer ? manufacturer : "Manufacturer"}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {filters[0]?.manufacturers.map((manufacturer) => (
                                <Dropdown.Item
                                  onClick={() => {
                                    setShowApplyFilter(true);
                                    setManufacturer(manufacturer.manufacturer);
                                  }}
                                >
                                  {manufacturer.manufacturer}
                                </Dropdown.Item>
                              ))}
                            </Dropdown.Menu>
                          </PageSizeDropdown>
                        </FilterContainer>
                      </FilterCol>
                      <FilterCol xs={12}>
                        <FilterContainer>
                          <PageSizeDropdown>
                            <Dropdown.Toggle variant="secondary">
                              {coreType
                                ? coreType == "0"
                                  ? "Symetric"
                                  : "Asymetric"
                                : "Core Type"}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {filters[0]?.core_types.map((core_type) =>
                                core_type.core_type !== "" ? (
                                  <Dropdown.Item
                                    onClick={() => {
                                      setShowApplyFilter(true);
                                      setCoreType(core_type.core_type);
                                    }}
                                  >
                                    {core_type.core_type == "0"
                                      ? "Symetric"
                                      : "Asymetric"}
                                  </Dropdown.Item>
                                ) : null
                              )}
                            </Dropdown.Menu>
                          </PageSizeDropdown>
                        </FilterContainer>
                      </FilterCol>
                      <FilterCol xs={12}>
                        <FilterContainer>
                          <PageSizeDropdown>
                            <Dropdown.Toggle variant="secondary">
                              {coverstock ? coverstock : "Coverstock"}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {filters[0]?.coverstocks.map((coverstock) => (
                                <Dropdown.Item
                                  onClick={() => {
                                    setShowApplyFilter(true);
                                    setCoverstock(coverstock.coverstock);
                                  }}
                                >
                                  {coverstock.coverstock}
                                </Dropdown.Item>
                              ))}
                            </Dropdown.Menu>
                          </PageSizeDropdown>
                        </FilterContainer>
                      </FilterCol>
                      <Col xs={12}>
                        <FilterContainer>
                          <FilterCheck
                            type={"switch"}
                            label={`RG`}
                            checked={useRGFilter}
                            onClick={() => {
                              setUseRGFilter(!useRGFilter);
                              setShowApplyFilter(true);
                            }}
                          />
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                              flex: 3,
                            }}
                          >
                            <ButtonGroup size={"sm"}>
                              <Button
                                variant="secondary"
                                style={{ fontSize: 10 }}
                                onClick={() => {
                                  setShowApplyFilter(true);
                                  setRgMinValue(searchBaseFilters.rg[0]);
                                  setRgMaxValue(2.51);
                                }}
                                disabled={!useRGFilter}
                              >
                                LOW
                              </Button>
                              <Button
                                variant="secondary"
                                style={{ fontSize: 10 }}
                                onClick={() => {
                                  setShowApplyFilter(true);
                                  setRgMinValue(2.52);
                                  setRgMaxValue(2.55);
                                }}
                                disabled={!useRGFilter}
                              >
                                MEDIUM
                              </Button>
                              <Button
                                variant="secondary"
                                style={{ fontSize: 10 }}
                                onClick={() => {
                                  setShowApplyFilter(true);
                                  setRgMinValue(2.56);
                                  setRgMaxValue(searchBaseFilters.rg[1]);
                                }}
                                disabled={!useRGFilter}
                              >
                                HIGH
                              </Button>
                            </ButtonGroup>
                            <RangeSelector
                              min={searchBaseFilters.rg[0]}
                              max={searchBaseFilters.rg[1]}
                              step={0.01}
                              decimals={3}
                              ruler={false}
                              label={true}
                              preventWheel={true}
                              minValue={rgMinValue}
                              maxValue={rgMaxValue}
                              onChange={(e) => {
                                setShowApplyFilter(true);
                                setRgMinValue(e.minValue);
                                setRgMaxValue(e.maxValue);
                              }}
                            />
                          </div>
                        </FilterContainer>
                      </Col>
                      <Col xs={12}>
                        <FilterContainer>
                          <FilterCheck
                            type={"switch"}
                            label={`DIFF`}
                            checked={useDiffFilter}
                            onClick={() => {
                              setUseDiffFilter(!useDiffFilter);
                              setShowApplyFilter(true);
                            }}
                          />
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                              flex: 3,
                            }}
                          >
                            <ButtonGroup size={"sm"}>
                              <Button
                                variant="secondary"
                                style={{ fontSize: 10 }}
                                onClick={() => {
                                  setShowApplyFilter(true);
                                  setDiffMinValue(searchBaseFilters.diff[0]);
                                  setDiffMaxValue(0.029);
                                }}
                                disabled={!useDiffFilter}
                              >
                                LOW
                              </Button>
                              <Button
                                variant="secondary"
                                style={{ fontSize: 10 }}
                                onClick={() => {
                                  setShowApplyFilter(true);
                                  setDiffMinValue(0.03);
                                  setDiffMaxValue(0.05);
                                }}
                                disabled={!useDiffFilter}
                              >
                                MEDIUM
                              </Button>
                              <Button
                                variant="secondary"
                                style={{ fontSize: 10 }}
                                onClick={() => {
                                  setShowApplyFilter(true);
                                  setDiffMinValue(0.051);
                                  setDiffMaxValue(searchBaseFilters.diff[1]);
                                }}
                                disabled={!useDiffFilter}
                              >
                                HIGH
                              </Button>
                            </ButtonGroup>
                            <RangeSelector
                              min={searchBaseFilters.diff[0]}
                              max={searchBaseFilters.diff[1]}
                              step={0.001}
                              decimals={3}
                              ruler={false}
                              label={true}
                              preventWheel={false}
                              minValue={diffMinValue}
                              maxValue={diffMaxValue}
                              onChange={(e) => {
                                setShowApplyFilter(true);
                                setDiffMinValue(e.minValue);
                                setDiffMaxValue(e.maxValue);
                              }}
                            />
                          </div>
                        </FilterContainer>
                      </Col>

                      <FilterCol
                        xs={12}
                        style={{
                          display: "flex",
                          justifyContent: "space-evenly",
                          alignItems: "center",
                        }}
                      >
                        {showApplyFilter && (
                          <Button
                            variant="success"
                            onClick={() => {
                              setShowDiscardFilter(true);
                              setShowApplyFilter(false);
                              handleBallSearch({
                                filter: ballSearch,
                                rangeInitial,
                                rangeFinal,
                                order,
                                filters: {
                                  rg: [rgMinValue, rgMaxValue],
                                  diff: [diffMinValue, diffMaxValue],
                                  int: [intMinValue, intMaxValue],
                                  size,
                                  manufacturer,
                                  core_type: coreType,
                                  core_name: coreName,
                                  coverstock,
                                },
                              });
                            }}
                          >
                            Apply <Check />
                          </Button>
                        )}
                        {showDiscardFilter && (
                          <Button
                            variant="danger"
                            onClick={() => {
                              setRgMinValue(searchBaseFilters.rg[0]);
                              setRgMaxValue(searchBaseFilters.rg[1]);
                              setDiffMinValue(searchBaseFilters.diff[0]);
                              setDiffMaxValue(searchBaseFilters.diff[1]);
                              setIntMinValue(searchBaseFilters.int[0]);
                              setIntMaxValue(searchBaseFilters.int[1]);
                              setSize();
                              setManufacturer();
                              setCoreType();
                              setCoreName();
                              setCoverstock();
                              setShowDiscardFilter(false);

                              handleBallSearch({
                                filter: ballSearch,
                                rangeInitial,
                                rangeFinal,
                                order,
                                filters: {
                                  rg: [
                                    searchBaseFilters.rg[0],
                                    searchBaseFilters.rg[1],
                                  ],
                                  diff: [
                                    searchBaseFilters.diff[0],
                                    searchBaseFilters.diff[1],
                                  ],
                                  int: [
                                    searchBaseFilters.int[0],
                                    searchBaseFilters.int[1],
                                  ],
                                  size: null,
                                  manufacturer: null,
                                  core_type: null,
                                  core_name: null,
                                  coverstock: null,
                                },
                              });
                            }}
                          >
                            Remove <X />
                          </Button>
                        )}
                      </FilterCol>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </IonContent>
        </IonMenu>
        <IonPage id="index-page">
          <div style={IonHeaderStyle}>
            <div style={{ marginTop: "1em", marginBottom: "1em" }}>
              <Row>
                <Col
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Form.Control
                    type="text"
                    value={ballSearch}
                    onChange={(e) => {
                      setBallSearch(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleBallSearch({
                          filter: ballSearch,
                          rangeInitial,
                          rangeFinal,
                          order,
                          filters: {
                            rg: [
                              searchBaseFilters.rg[0],
                              searchBaseFilters.rg[1],
                            ],
                            diff: [
                              searchBaseFilters.diff[0],
                              searchBaseFilters.diff[1],
                            ],
                          },
                        });
                      }
                    }}
                    placeholder="Search..."
                    style={{
                      width: isPhone ? "65%" : "50%",
                    }}
                  />
                  <Button
                    variant="outline-success"
                    onClick={() =>
                      handleBallSearch({
                        filter: ballSearch,
                        rangeInitial,
                        rangeFinal,
                        order,
                        filters: {
                          rg: [
                            searchBaseFilters.rg[0],
                            searchBaseFilters.rg[1],
                          ],
                          diff: [
                            searchBaseFilters.diff[0],
                            searchBaseFilters.diff[1],
                          ],
                        },
                      })
                    }
                    style={{ marginLeft: 10 }}
                  >
                    <Search />
                  </Button>
                  {!isPhone && (
                    <Button
                      variant={"outline-secondary"}
                      onClick={() => {
                        setIsList(isList ? false : "true");
                      }}
                      style={{ marginLeft: 10 }}
                    >
                      {isList ? <Grid /> : <CardList />}
                    </Button>
                  )}
                  <Button
                    variant={"outline-primary"}
                    onClick={() => menuController.open("filter-menu")}
                    style={{ marginLeft: 10 }}
                  >
                    <Funnel></Funnel>
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
          <div
            style={{
              overflowY: "scroll",
              minHeight: "100%",
              paddingBottom: 100,
            }}
          >
            {loading && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  width: "100%",
                }}
              >
                <IonSpinner></IonSpinner>
              </div>
            )}
            {isList ? (
              <Table striped style={TableStyle}>
                <thead>
                  <tr
                    style={{
                      position: "sticky",
                      top: 0,
                      background: "#FFFFFF",
                    }}
                  >
                    <TableHeader></TableHeader>
                    <TableHeader>MANUFACTURER</TableHeader>
                    <TableHeader>NAME</TableHeader>
                    <TableHeader>RELEASE DATE</TableHeader>
                    <TableHeader>INFO. DATE</TableHeader>
                    <TableHeader>M.A.P</TableHeader>
                  </tr>
                </thead>
                <tbody>
                  {bowlingdata.map((ball) => (
                    <tr
                      onClick={() => {
                        getBalldatabaseInfo({ ids: ball.ids });
                        setShowBallInfo(true);
                        setSelectedBall(ball);
                      }}
                    >
                      <TableData>
                        <img
                          src={ball.image_url}
                          alt="Ball"
                          style={{
                            width: 100,
                            height: 100,
                          }}
                        />
                      </TableData>
                      <TableData>{ball.manufacturer}</TableData>
                      <TableData>{ball.name}</TableData>
                      <TableData>
                        {ball.release_date
                          ? moment(ball.release_date, "YYYYMMDD").format(
                              "YYYY/MM/DD"
                            )
                          : ""}
                      </TableData>
                      <TableData>
                        {ball.information_date
                          ? moment(ball.information_date).format("YYYY/MM/DD")
                          : ""}
                      </TableData>
                      <TableData>{ball.map}</TableData>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <Row style={divTileStyle}>
                {bowlingdata.map((ball) => (
                  <Col xs={12} md={6} lg={6}>
                    <Tile
                      onClick={() => {
                        getBalldatabaseInfo({ ids: ball.ids });
                        setShowBallInfo(true);
                        setSelectedBall(ball);
                      }}
                    >
                      <img
                        src={ball.image_url}
                        alt="Ball"
                        style={{
                          width: 100,
                          height: 100,
                          marginLeft: 20,
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          flexWrap: "wrap",
                          justifyContent: "center",
                          alignItems: "flex-start",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "bold",
                            size: 12,
                          }}
                        >
                          {ball.manufacturer}
                        </span>
                        <span style={{ size: 9, maxWidth: 160 }}>
                          {ball.name}
                        </span>
                        <span style={{ size: 9 }}>
                          {`Release Date: ${
                            ball.release_date
                              ? moment(ball.release_date, "YYYYMMDD").format(
                                  "YYYY/MM/DD"
                                )
                              : ""
                          }`}
                        </span>
                        <span style={{ size: 9 }}>
                          {`Info. Date: ${
                            ball.info_date
                              ? moment(ball.info_date).format("YYYY/MM/DD")
                              : ""
                          }`}
                        </span>
                        <span style={{ size: 9 }}>{`M.A.P ${ball.map}`}</span>
                      </div>
                    </Tile>
                  </Col>
                ))}
              </Row>
            )}
          </div>
          <Modal
            centered
            size="lg"
            show={showBallInfo}
            onHide={() => {
              setShowBallInfo(false);
            }}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {selectedBall
                  ? `${selectedBall.name} ${selectedBall.manufacturer}`
                  : ""}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {loading && <IonSpinner></IonSpinner>}
              {!loading && (
                <Table striped size="sm">
                  <thead>
                    <tr>
                      <th>SIZE</th>
                      <th>RG</th>
                      <th>DIFF</th>
                      <th>INT DIFF</th>
                      <th>CORE</th>
                      <th>SURFACE</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedBalls
                      .slice()
                      .sort((a, b) => a.size - b.size)
                      .map((ball) => (
                        <tr
                          onClick={() => {
                            onSelect(ball);
                            setShowBallInfo(false);
                          }}
                        >
                          <td>{ball.size}</td>
                          <td>{ball.rg}</td>
                          <td>{ball.diff}</td>
                          <td>{ball.int}</td>
                          <td>{`${ball.core_type} ${ball.core_name}`}</td>
                          <td>{`${ball.coverstock} ${ball.surface}`}</td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => {
                  setShowBallInfo(false);
                }}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </IonPage>
      </Modal.Body>
      <Modal.Footer style={{ justifyContent: "center" }}>
        <Pagination>
          <Pagination.First
            onClick={() => {
              setActPage(1);
              setRangeInitial(pageSize * (1 - 1));
              setRangeFinal(pageSize * 1 - 1);
              handleBallSearch(ballSearch, 0, pageSize - 1);
            }}
          />
          <Pagination.Prev
            onClick={() => {
              if (actPage > 1) {
                setActPage(actPage - 1);
                setRangeInitial(pageSize * (actPage - 1 - 1));
                setRangeFinal(pageSize * (actPage - 1) - 1);
                handleBallSearch(
                  ballSearch,
                  pageSize * (actPage - 1 - 1),
                  pageSize * (actPage - 1) - 1
                );
              }
            }}
          />
          {getPages()}
          <Pagination.Next
            onClick={() => {
              if (actPage < getEndPage()) {
                setActPage(actPage + 1);
                setRangeInitial(pageSize * (actPage + 1 - 1));
                setRangeFinal(pageSize * (actPage + 1) - 1);
                handleBallSearch(
                  ballSearch,
                  pageSize * (actPage + 1 - 1),
                  pageSize * (actPage + 1) - 1
                );
              }
            }}
          />
          <Pagination.Last
            onClick={() => {
              let endPage = getEndPage();
              setActPage(getEndPage());
              setRangeInitial(pageSize * (getEndPage() - 1));
              setRangeFinal(pageSize * getEndPage() - 1);
              handleBallSearch(
                ballSearch,
                pageSize * (endPage - 1),
                pageSize * endPage - 1
              );
            }}
          />
        </Pagination>
      </Modal.Footer>
    </>
  );
};

export default BallSearch;
